export default __webpack_public_path__ + "static/bg_glow_footer_mobile-4c9c7a68db14775cd18e312dcc1a66a0.png";